export const ProfileRoutes = {
	Engagements: '/admin/engagements',
	EngagementDetails: '/admin/engagements/:engagementId',
	EngagementDetailsLL: '/admin/engagements/:engagementId/item/:engagementItemId?',
	Root: '/admin/dashboard',
	Analytics: '/admin/analytics',
	Profile: '/profile',
	SecuritySettings: '/profile/security',
	Providers: '/admin/providers',
	ProviderDetails: '/admin/providers/:providerId',
	Districts: '/admin/districts',
	Families: '/admin/families',
	FamilyDetails: '/admin/families/:familyId',
	Distribute: '/distribute',
	SurveyTemplates: {
		Root: '/admin/survey-templates',
		Creating: '/admin/surveys-templates/creating',
		Editing: '/admin/survey-templates/editing/:surveyTemplateId',
		Overview: '/admin/survey-templates/:surveyTemplateId',
		QuestionStats: '/admin/survey-templates/:surveyTemplateId/question-answers/:questionId',
		FamilyStats: '/admin/survey-templates/:surveyTemplateId/family-answers/:phoneNumber',
	},
};
